export const EVENTS = {
    BOOKMAKER_CHANGED: 'bookieChanged.BOOKMAKER',
    INFO_TOPIC_UPDATED: 'infoTopicUpdate.PRICES',
    SETTINGS_CHANGED: 'userSettingsChanged.SETTINGS'
};

export const PAGES = {
    FREE_CARD: Symbol('Free Card Page'),
    PRO_CARD: Symbol('Pro Card Page'),
    STABLE_TOURS: Symbol('Stable Tours Page'),
    MEETING_DAY: Symbol('Meeting Day Page'),
    GLANCE_CARD: Symbol('Glance Card Page'),
    LIVE_TAB: Symbol('Live tab')
};

export const PAGE_SELECTORS = {
    [PAGES.FREE_CARD]: '.js-RC-freeCard',
    [PAGES.PRO_CARD]: '.js-RC-proCard',
    [PAGES.STABLE_TOURS]: '.js-RC-stableTour',
    [PAGES.MEETING_DAY]: '.js-RC-meetingDay',
    [PAGES.GLANCE_CARD]: '.js-RC-glanceCard',
    [PAGES.LIVE_TAB]: '.js-RC-liveTab'
};

export const feedBookieMap = {
    WH_OXI: 'williamHill',
    '#BESTODDS': 'bestOdds',
    LADB: 'ladbrokes',
    BET365: 'bet365', // Betslip specific
    CORAL: 'coral',
    PPWR: 'paddypower',
    BETFAIR: 'betfair',
    VC: 'betVictor',
    // 'SPORTING INDEX': 'sportingBet',
    SURREY: 'skybet',
    BOLEYSPORTS: 'boylesport',
    TOTE: 'tote',
    BETFRED: 'betfred',
};



// WEBPACK FOOTER //
// ./lib/js/constants.js